import { setCookie } from './helpers';

if (document.querySelector('.products__grid, .team-members') !== null) {
  document.querySelectorAll('.product__single:not(.product-category), div.team-members__content > div.team-members__content--excerpt > button').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();

      const target = e.currentTarget;
      const targetProduct = target.nextElementSibling;

      if (document.querySelector('.product__popup.active') !== null) {
        document.querySelectorAll('.product__popup').forEach(ef => {
          ef.classList.remove('active');
          document.querySelector('.page--shadow').classList.remove('visible');
          document.body.classList.remove('overflow--disable');
        });
      }

      targetProduct.classList.add('active');
      document.querySelector('.page--shadow').classList.add('visible');
      document.body.classList.add('overflow--disable');
    });
  });

  document.querySelectorAll('.product__popup__close').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      const target = e.currentTarget;

      target.closest('.product__popup.active').classList.remove('active');
      document.querySelector('.page--shadow').classList.remove('visible');
      document.body.classList.remove('overflow--disable');
    });
  });

  document.querySelector('.page--shadow').addEventListener('click', () => {
    document.querySelectorAll('.product__popup').forEach(eq => {
      eq.classList.remove('active');
    });
    document.querySelector('.page--shadow.visible').classList.remove('visible');
    document.body.classList.remove('overflow--disable');
  });

  if (document.querySelector('.woocommerce-posts-per-page select') !== null) {

    document.querySelector('.woocommerce-posts-per-page select').addEventListener('change', e => {
      e.preventDefault();
      const { value } = e.target.options[e.target.selectedIndex];

      setCookie('ws_posts_per_page', value, 300);
      window.location.reload();
    });
  }
}
